<template>
  <v-card>
    <!-- ABAS -->
    <v-tabs v-model="aba" background-color="transparent" grow>
      <v-tab>Entradas Pendentes</v-tab>
      <v-tab>Entradas Manual</v-tab>
    </v-tabs>

    <v-tabs-items v-model="aba">
      <!-- ===== ABA 1: GRID AGRUPADO (Fornecedores -> Pedidos -> Produtos) ===== -->
      <v-tab-item>
        <v-card flat>
          <v-card-title class="justify-space-between">
            <span class="text-h6">Pedidos por Fornecedor</span>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar fornecedor / CNPJ / Nº Pedido"
              dense
              hide-details
              clearable
              style="max-width: 420px"
            />
          </v-card-title>

          <v-data-table
            :headers="headersFornecedor"
            :items="gruposFiltrados"
            :search="''"
            item-key="idFornecedor"
            show-expand
            :expanded.sync="expandedFornecedores"
            single-expand
            class="elevation-1"
            dense
          >
            <template #item.totalFornecedor="{ item }">
              {{ money(item.totalFornecedor) }}
            </template>

            <template #expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="pa-0 expanded-pane">
                <div class="expanded-surface">
                  <!-- Tabela de pedidos do fornecedor -->
                  <v-data-table
                    :headers="headersPedido"
                    :items="item.pedidos"
                    item-key="id"
                    dense
                    class="elevation-0 stripe-rows"
                    show-expand
                    :expanded.sync="expandedPedidos"
                    single-expand
                  >
                    <template #item.subtotal="{ item: p }">
                      {{ money(p._subtotalCalc) }}
                    </template>
                    <template #item.acrescimo="{ item: p }">
                      {{ money(p._acrescimoCalc) }}
                    </template>
                    <template #item.desconto="{ item: p }">
                      {{ money(p._descontoCalc) }}
                    </template>
                    <template #item.total="{ item: p }">
                      {{ money(p._totalCalc) }}
                    </template>
                    <template #item.dataCriacao="{ item: p }">
                      {{ formatDate(p.dataCriacao) }}
                    </template>
                    <template #item.acoes="{ item: p }">
                      <v-tooltip bottom>
                        <template #activator="{ on, attrs }">
                          <v-btn
                            icon
                            small
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop="emitPedidoCompleto(p)"
                          >
                            <v-icon>mdi-playlist-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>Adicionar todo pedido</span>
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template #activator="{ on, attrs }">
                          <v-btn
                            icon
                            small
                            color="success"
                            :disabled="
                              !(
                                currentPedidoIdExpanded === p.id &&
                                hasSelecionados(p.id)
                              )
                            "
                            @click.stop="emitProdutosSelecionados(p)"
                          >
                            <v-icon>mdi-plus-box-multiple</v-icon>
                          </v-btn>
                        </template>
                        <span>Adicionar selecionados</span>
                      </v-tooltip>
                    </template>

                    <!-- Produtos (nÃ­vel 2) -->
                    <template #expanded-item="{ headers, item: p }">
                      <td :colspan="headers.length" class="pa-0 expanded-inner">
                        <v-simple-table dense class="expanded-products">
                          <thead>
                            <tr>
                              <th>Produto</th>
                              <th>CÃ³digo</th>
                              <th>UM</th>
                              <th>Centro de Custo</th>
                              <th>Local Entrega</th>
                              <th>Qtd</th>
                              <th>Vlr Unit.</th>
                              <th>Total</th>
                              <th style="width: 40px"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="prod in p.produtos"
                              :key="prod.idMapaCotacaoItem || prod.id"
                            >
                              <td>{{ prod.produto }}</td>
                              <td>{{ prod.codigo || "-" }}</td>
                              <td>{{ prod.unidadeMedida }}</td>
                              <td>{{ prod.centroCusto }}</td>
                              <td>{{ prod.localEntrega }}</td>
                              <td>{{ prod.quantidade }}</td>
                              <td>{{ money(prod.valorUnitario) }}</td>
                              <td>{{ money(prod.total) }}</td>
                              <v-checkbox
                                hide-details
                                dense
                                :disabled="!canSelectFromPedido(p.id)"
                                :input-value="
                                  isProdutoSelecionado(p.id, keyDoProduto(prod))
                                "
                                @change="
                                  toggleProduto(p.id, keyDoProduto(prod), prod)
                                "
                              />
                            </tr>
                          </tbody>
                        </v-simple-table>
                      </td>
                    </template>
                  </v-data-table>
                </div>
              </td>
            </template>

            <template #no-data> Nenhum registro encontrado. </template>
          </v-data-table>
        </v-card>
      </v-tab-item>

      <!-- ===== ABA 2: GRID SIMPLES (id + nome) ===== -->
      <v-tab-item>
        <v-card flat>
          <v-card-title class="justify-space-between">
            <span class="text-subtitle-1">Lista de Fornecedores</span>
            <v-text-field
              v-model="searchFornecedor"
              append-icon="mdi-magnify"
              label="Pesquisar nome / CNPJ"
              dense
              hide-details
              clearable
              style="max-width: 420px"
            />
          </v-card-title>

          <v-data-table
            :headers="headersFornecedoresSimples"
            :items="fornecedoresFiltrados"
            :search="searchFornecedor"
            item-key="id"
            :items-per-page="10"
            class="elevation-1"
            dense
          >
            <template #item.id="{ item }">
              <strong>{{ item.id }}</strong>
            </template>
            <template #item.nome="{ item }">
              {{ item.nome }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="info"
                    class="mr-2"
                    fab
                    x-small
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="emitFornecedorSelecionados(item)"
                  >
                    <v-icon> mdi-plus </v-icon>
                  </v-btn>
                </template>
                <span>Selecionar fornecedor</span>
              </v-tooltip>
            </template>

            <template #no-data> Nenhum fornecedor encontrado. </template>
          </v-data-table>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Fornecedor",
  props: {
    /** Aba 1: lista BRUTA recebida da API (pedidos) */
    itens: { type: Array, default: () => [] },
    /** Aba 2: lista simples de fornecedores (id, nome, etc.) */
  },
  data() {
    return {
      aba: 0,
      search: "",
      searchFornecedor: "",
      selectedProdutosByPedido: {},
      currentFornecedorIdExpanded: null,
      currentPedidoIdExpanded: null,
      expandedFornecedores: [],
      expandedPedidos: [],
      headersFornecedor: [
        { text: "Fornecedor", value: "fornecedor", width: 300 },
        { text: "CNPJ", value: "cnpjFornecedor", width: 160 },
        {
          text: "Qtde Pedidos",
          value: "quantidadePedidos",
          align: "end",
          width: 130,
        },
        {
          text: "Total Fornecedor",
          value: "totalFornecedor",
          align: "end",
          width: 160,
        },
        {
          text: "",
          value: "data-table-expand",
          sortable: false,
          align: "center",
          width: 48,
        },
      ],
      headersPedido: [
        { text: "Pedido (ID)", value: "id", width: 110 },
        { text: "Status", value: "status", width: 90 },
        { text: "Data", value: "dataCriacao", width: 140 },
        { text: "Comprador", value: "comprador" },
        { text: "Autorizador", value: "autorizador" },
        { text: "Total", value: "total", align: "end", width: 120 },
        { text: "Produtos", value: "qtdeProdutos", align: "end", width: 110 },
        {
          text: "Ações",
          value: "acoes",
          sortable: false,
          align: "center",
          width: 120,
        },
        {
          text: "",
          value: "data-table-expand",
          sortable: false,
          align: "center",
          width: 48,
        },
      ],
      headersFornecedoresSimples: [
        { text: "ID", value: "id", width: 90 },
        { text: "Nome", value: "nome" },
        { text: "CNPJ", value: "cpf_Cnpj" },
        { text: "", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    ...mapState("fornecedor", ["fornecedores"]),
    /** Normaliza e agrupa a lista bruta (Aba 1) */
    grupos() {
      const normalizados = this.itens.map((p) => {
        const hasProdutos = Array.isArray(p.produtos) && p.produtos.length > 0;

        const somaProdutos = hasProdutos
          ? p.produtos.reduce(
              (acc, prod) => {
                const sub = Number(prod.subTotal || 0);
                const descProd = Number(prod.descontoProduto || 0);
                const total = Number(prod.total || sub - descProd);
                return {
                  subtotal: acc.subtotal + sub,
                  desconto: acc.desconto + descProd,
                  total: acc.total + total,
                };
              },
              { subtotal: 0, desconto: 0, total: 0 }
            )
          : { subtotal: 0, desconto: 0, total: 0 };

        const subtotalCalc =
          p.subtotal && p.subtotal > 0
            ? Number(p.subtotal)
            : somaProdutos.subtotal;
        const acrescimoCalc = Number(p.acrescimo || 0);
        const descontoCalc =
          p.descontoSomado && p.descontoSomado > 0
            ? Number(p.descontoSomado)
            : Number(p.descontoAdicional || 0) + somaProdutos.desconto;

        const totalCalc =
          p.total && p.total > 0
            ? Number(p.total)
            : subtotalCalc + acrescimoCalc - descontoCalc;

        return {
          ...p,
          _subtotalCalc: subtotalCalc,
          _acrescimoCalc: acrescimoCalc,
          _descontoCalc: descontoCalc,
          _totalCalc: totalCalc,
          qtdeProdutos: hasProdutos ? p.produtos.length : 0,
        };
      });

      const byFornecedor = normalizados.reduce((map, p) => {
        const key = p.idFornecedor;
        if (!map[key]) {
          map[key] = {
            idFornecedor: p.idFornecedor,
            fornecedor: p.fornecedor,
            cnpjFornecedor: p.cnpjFornecedor,
            pedidos: [],
          };
        }
        map[key].pedidos.push(p);
        return map;
      }, {});

      const gruposArr = Object.values(byFornecedor).map((g) => {
        const totalFornecedor = g.pedidos.reduce(
          (acc, p) => acc + Number(p._totalCalc || 0),
          0
        );
        return {
          ...g,
          quantidadePedidos: g.pedidos.length,
          totalFornecedor,
        };
      });

      gruposArr.sort((a, b) =>
        (a.fornecedor || "").localeCompare(b.fornecedor || "")
      );
      return gruposArr;
    },
    gruposFiltrados() {
      const q = (this.search || "").trim();
      if (!q) return this.grupos;

      const qLower = q.toLowerCase();

      // Detecta se a consulta parece um ID de pedido (ex.: "13", "#13", "id:13")
      const idMatch = q.match(/^(?:#|id:)?\s*(\d+)\s*$/i);
      const searchId = idMatch ? idMatch[1] : null;

      return this.grupos.filter((g) => {
        // 1) match em campos do grupo (fornecedor, cnpj, contato, telefone â€“ se existirem)
        const matchGrupo = [g.fornecedor, g.cnpjFornecedor].some((v) =>
          (v || "").toLowerCase().includes(qLower)
        );

        // 2) match dentro dos pedidos
        const matchPedidos =
          Array.isArray(g.pedidos) &&
          g.pedidos.some((p) => {
            // Se a query Ã© ID, procura no nÃºmero do pedido
            if (searchId) return String(p.id).includes(searchId);

            // Caso contrÃ¡rio, procura em alguns campos do pedido e tambÃ©m no prÃ³prio ID
            return (
              [p.status, p.comprador, p.autorizador, p.numeroOrcamento].some(
                (v) => (v || "").toLowerCase().includes(qLower)
              ) || String(p.id).includes(q)
            ); // permite digitar "13" e achar pelo id
          });

        return matchGrupo || matchPedidos;
      });
    },

    /** Aba 2: permite buscar por nome, fantasia ou CNPJ */
    fornecedoresFiltrados() {
      if (!this.searchFornecedor)
        return this.fornecedores
          .filter((f) => {
            return f.ativo === true;
          })
          .sort(function (a, b) {
            return b.id - a.id;
          });
      const q = this.searchFornecedor.toLowerCase();
      return this.fornecedores
        .filter(
          (f) =>
            ((f.nome || "").toLowerCase().includes(q) ||
              (f.nomeFantasia || "").toLowerCase().includes(q) ||
              (f.cpf_Cnpj || "").toLowerCase().includes(q)) &&
            f.ativo === true
        )
        .sort(function (a, b) {
          return b.id - a.id;
        });
    },
  },
  methods: {
    money(v) {
      const n = Number(v || 0);
      return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
    formatDate(iso) {
      if (!iso) return "-";
      const d = new Date(iso);
      if (isNaN(d.getTime())) return "-";
      return d.toLocaleString("pt-BR");
    },
    keyDoProduto(prod) {
      // chave Ãºnica do produto dentro do pedido
      return prod.idMapaCotacaoItem || prod.id;
    },
    ensureBucket(pedidoId) {
      if (!this.selectedProdutosByPedido[pedidoId]) {
        // usamos Set pra evitar duplicados
        this.$set(this.selectedProdutosByPedido, pedidoId, new Set());
      }
    },
    isProdutoSelecionado(pedidoId, key) {
      const bucket = this.selectedProdutosByPedido[pedidoId];
      return bucket ? bucket.has(key) : false;
    },
    toggleProduto(pedidoId, key, _prodRef) {
      this.ensureBucket(pedidoId);
      const bucket = this.selectedProdutosByPedido[pedidoId];
      if (bucket.has(key)) bucket.delete(key);
      else bucket.add(key);
      // forÃ§a reatividade do Set
      this.$set(this.selectedProdutosByPedido, pedidoId, new Set(bucket));
    },
    hasSelecionados(pedidoId) {
      const bucket = this.selectedProdutosByPedido[pedidoId];
      return bucket && bucket.size > 0;
    },
    getSelecionadosObjetos(pedido) {
      const bucket = this.selectedProdutosByPedido[pedido.id];
      if (!bucket || bucket.size === 0) return [];
      const keys = Array.from(bucket);
      // mantÃ©m a ordem original:
      return (pedido.produtos || []).filter((prod) =>
        keys.includes(this.keyDoProduto(prod))
      );
    },
    itensComDadosPedido(pedido, itens) {
      return (itens || []).map((item) => ({
        ...item,
        idPedido: pedido.id,
        tipoPedido: pedido.tipoPedido,
      }));
    },
    emitPedidoCompleto(pedido) {
      const itens = this.itensComDadosPedido(pedido, pedido.produtos || []);
      const payload = {
        tipo: "pedido",
        fornecedorId: pedido.idFornecedor,
        pedidoId: pedido.id,
        acrescimo: pedido.acrescimo,
        desconto: pedido.descontoAdicional,
        subtotal: pedido.subtotal,
        total: pedido.total,
        tipoPedido: pedido.tipoPedido,
        itens, // todos os produtos do pedido
      };
      this.$emit("adicionar", payload);
    },
    emitProdutosSelecionados(pedido) {
      const itens = this.itensComDadosPedido(pedido, this.getSelecionadosObjetos(pedido));
      if (itens.length === 0) return;
      const payload = {
        tipo: "produtos",
        fornecedorId: pedido.idFornecedor,
        pedidoId: pedido.id,
        acrescimo: pedido.acrescimo,
        desconto: pedido.descontoAdicional,
        subtotal: pedido.subtotal,
        total: pedido.total,
        tipoPedido: pedido.tipoPedido,
        itens, // apenas selecionados
      };
      this.$emit("adicionar", payload);
      // limpa seleÃ§Ã£o desse pedido (opcional)
      this.$delete(this.selectedProdutosByPedido, pedido.id);
    },

    emitFornecedorSelecionados(fornecedor) {
      const itens = this.getSelecionadosObjetos(fornecedor);
      const payload = {
        tipo: "fornecedor",
        fornecedorId: fornecedor.id,
        pedidoId: null,
        itens: null,
      };
      this.$emit("adicionar", payload);
      // limpa seleÃ§Ã£o desse pedido (opcional)
      this.$delete(this.selectedProdutosByPedido, pedido.id);
    },
    resetSelections() {
      // limpa TODAS as seleÃ§Ãµes de produtos
      this.selectedProdutosByPedido = {};
    },

    ensureBucket(pedidoId) {
      if (!this.selectedProdutosByPedido[pedidoId]) {
        this.$set(this.selectedProdutosByPedido, pedidoId, new Set());
      }
    },

    keyDoProduto(prod) {
      return prod.idMapaCotacaoItem || prod.id;
    },

    canSelectFromPedido(pedidoId) {
      // sÃ³ permite marcar produtos do pedido atualmente expandido/selecionado
      return (
        !this.currentPedidoIdExpanded ||
        this.currentPedidoIdExpanded === pedidoId
      );
    },

    toggleProduto(pedidoId, key, _prodRef) {
      // se tentar selecionar de outro pedido, zera e troca o â€œpedido correnteâ€
      if (
        this.currentPedidoIdExpanded &&
        this.currentPedidoIdExpanded !== pedidoId
      ) {
        this.resetSelections();
        this.currentPedidoIdExpanded = pedidoId;
      }

      this.ensureBucket(pedidoId);
      const bucket = this.selectedProdutosByPedido[pedidoId];

      if (bucket.has(key)) bucket.delete(key);
      else bucket.add(key);

      // forÃ§a reatividade do Set
      this.$set(this.selectedProdutosByPedido, pedidoId, new Set(bucket));
    },

    isProdutoSelecionado(pedidoId, key) {
      const bucket = this.selectedProdutosByPedido[pedidoId];
      return bucket ? bucket.has(key) : false;
    },

    hasSelecionados(pedidoId) {
      const bucket = this.selectedProdutosByPedido[pedidoId];
      return bucket && bucket.size > 0;
    },
  },
  /* Fallback caso seu Vuetify nÃ£o suporte single-expand */
  watch: {
    expandedFornecedores(val) {
      if (Array.isArray(val) && val.length > 1) {
        this.expandedFornecedores = [val[val.length - 1]];
      }
      const novoFornecedorId = val && val[0] ? val[0].idFornecedor : null;
      if (this.currentFornecedorIdExpanded !== novoFornecedorId) {
        this.resetSelections(); // ðŸ”¸ limpa tudo
        this.currentFornecedorIdExpanded = novoFornecedorId;
        this.currentPedidoIdExpanded = null; // nenhum pedido â€œcorrenteâ€
      }
    },

    // mantÃ©m 1 pedido expandido; e limpa seleÃ§Ã£o quando mudar de pedido
    expandedPedidos(val) {
      if (Array.isArray(val) && val.length > 1) {
        this.expandedPedidos = [val[val.length - 1]];
      }
      const novoPedidoId = val && val[0] ? val[0].id : null;
      if (this.currentPedidoIdExpanded !== novoPedidoId) {
        this.resetSelections(); // ðŸ”¸ limpa seleÃ§Ã£o ao trocar pedido
        this.currentPedidoIdExpanded = novoPedidoId;
      }
    },
  },
};
</script>

<style scoped>
/* Fundo suave para o painel expandido de fornecedor */
.theme--light .expanded-pane .expanded-surface {
  background: #f6f8fb;
  border-left: 4px solid #3f51b5; /* indigo-500 */
  padding: 12px 12px 8px;
}
.theme--dark .expanded-pane .expanded-surface {
  background: #1f2430;
  border-left: 4px solid #8ab4f8;
  padding: 12px 12px 8px;
}
/* ===== PEDIDOS (nÃ­vel 1) ===== */
.theme--light .expanded-pane .expanded-surface .v-data-table {
  background-color: #c0c0c0; /* cinza quase branco */
}
.theme--dark .expanded-pane .expanded-surface .v-data-table {
  background-color: #1e1e1e;
}
/* PRODUTOS: fundo padrÃ£o de linhas */
.theme--light .expanded-inner .expanded-products tbody tr {
  background-color: #fbfbfb;
}
.theme--dark .expanded-inner .expanded-products tbody tr {
  background-color: #232323;
}

/* PRODUTOS: alternÃ¢ncia prÃ³pria (se quiser manter zebra aqui tambÃ©m) */
.theme--light .expanded-inner .expanded-products tbody tr:nth-child(odd) {
  background-color: #fefefe;
}
.theme--dark .expanded-inner .expanded-products tbody tr:nth-child(odd) {
  background-color: #1f1f1f;
}

/* PRODUTOS: hover prÃ³prio (nÃ£o herdar do v-data-table pai) */
.theme--light .expanded-inner .expanded-products tbody tr:hover {
  background-color: #f0f0f0 !important;
}
.theme--dark .expanded-inner .expanded-products tbody tr:hover {
  background-color: #2b2b2b !important;
}

/* PRODUTOS: cabeÃ§alho diferenciado (barra) */
.theme--light .expanded-inner .expanded-products thead tr th {
  background: #e8f5e9; /* verdinho suave */
  border-bottom: 2px solid #80cbc4;
}
.theme--dark .expanded-inner .expanded-products thead tr th {
  background: #153328;
  border-bottom: 2px solid #2aa59a;
}
</style>
